import React from "react";
import { Link } from "react-router-dom";
import DeveloperStats from "./developer-stats";
import ActivityChart from "./ActivityChart";
import GameList from "./game-list";

function DeveloperOverview({ stats, games, basePath = "/developer" }) {
  return (
    <>
      <DeveloperStats stats={stats} />

      <div className="dev-card">
        <div className="dev-card-header">
          <h2 className="dev-card-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12,6 12,12 16,14" />
            </svg>
            Recent Activity: Playtesters
          </h2>
        </div>
        <div className="dev-card-body">
          <span className="dev-tag">playtesting</span>
          <ActivityChart games={games} />
          <p className="dev-card-caption">
            Games created on each day with assigned playtester counts are used for this summary.
          </p>
        </div>
      </div>

      <div className="dev-card">
        <div className="dev-card-header">
          <h2 className="dev-card-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12,6 12,12 16,14" />
            </svg>
            Recent Games
          </h2>
          <Link to={`${basePath}/games`} className="dev-link">
            View all
          </Link>
        </div>
        <div className="dev-card-body" style={{ padding: 0 }}>
          <GameList games={games} variant="table" limit={5} showToolbar={false} basePath={basePath} />
        </div>
      </div>
    </>
  );
}

export default DeveloperOverview;
